import api from "./api";

const subjectService = {
  // Get all subjects with search/filter
  getAllSubjects: async (params = {}) => {
    const response = await api.get("/api/subjects", { params });
    return response.data.data || response.data;
  },

  // Added by Farhan Khan on 22-June-2026 ( Using this to Fetch Active Data for dropdown )
  getActiveSubjectsByClass: async (classId) => {
    const response = await api.get(`/api/subjects/class/${classId}/active`);
    return response.data.data || response.data;
  },

  // Added by Farhan Khan on 22-June-2026 ( Using this to Fetch Active Data for dropdown )
  getActiveSubjectsBySemester: async (semesterId) => {
    const response = await api.get(`/api/subjects/semester/${semesterId}/active`);
    return response.data.data || response.data;
  },

  // Get subject by ID
  getSubjectById: async (id) => {
    const response = await api.get(`/api/subjects/${id}`);
    return response.data.data || response.data;
  },

  // Create new subject
  createSubject: async (subjectData) => {
    const response = await api.post("/api/subjects", subjectData);
    return response.data.data || response.data;
  },

  // Update subject
  updateSubject: async (id, subjectData) => {
    const response = await api.put(`/api/subjects/${id}`, subjectData);
    return response.data.data || response.data;
  },

  // Delete subject
  deleteSubject: async (id) => {
    const response = await api.delete(`/api/subjects/${id}`);
    return response.data.data || response.data;
  },
};

export default subjectService;
